import React, { Fragment, useState } from 'react';

import Typography from 'Atoms/Typography'

const TextArea = (
  {
    onChange,
    className,
    defaultValue = '',
    placeholder = '',
    id,
    label,
    characterLimit,
    rows
  }
) => {
  const [charactersRemaining, setCharactersRemaining] = useState(defaultValue.length > 0 ? characterLimit - defaultValue.length : characterLimit);

  return (
    <Fragment>
      <Typography as={'label'} htmlFor={id}>
        {label}
      </Typography>
      <Typography
        as={'textarea'}
        defaultValue={defaultValue.substr(0, characterLimit)}
        placeholder={placeholder}
        name={id}
        rows={rows}
        className={className}
        maxLength={characterLimit != 0 ? characterLimit : undefined}
        onChange={(e) => {onChange; setCharactersRemaining(characterLimit - e.target.value.length);}}>
      </Typography>
      {characterLimit != null && characterLimit > 0 ?
        <Typography>{charactersRemaining > 0 ? charactersRemaining : "No"} characters remaining</Typography>
        : false}
    </Fragment>
  )
}


export default TextArea;